import { fetchWithHandling } from "utils/common-utils";
import { PagedAdminNotifications } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/notifications`;

export const getAllPaginated = async (
    jwtToken: string,
    onSessionExpired: () => void,
    pageNumber: number = 0,
    pageSize: number = 10
): Promise<PagedAdminNotifications | undefined> => {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append('pageNumber', pageNumber.toString());
        queryParams.append('pageSize', pageSize.toString());

        const jsonData = await fetchWithHandling(
            `${API_URL}/paginated?${queryParams.toString()}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData as PagedAdminNotifications;
    } catch (error) {
        console.error('Error fetching notifications:', error);
        return undefined;
    }
};

export const getUnreadCount = async (
    jwtToken: string,
    onSessionExpired: () => void
): Promise<number | undefined> => {
    try {
        const jsonData = await fetchWithHandling(
            `${API_URL}/unread-count`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData as number;
    } catch (error) {
        console.error('Error fetching unread notification count:', error);
        return undefined;
    }
};

export const markAsRead = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number
): Promise<boolean> => {
    try {
        // isNotJsonResponse: the backend returns 204 No Content (nothing to mark-as-read back), so
        // fetchWithHandling must not try to .json() an empty body.
        await fetchWithHandling(
            `${API_URL}/${id}/read`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            },
            true
        );

        return true;
    } catch (error) {
        console.error(`Error marking notification ${id} as read:`, error);
        return false;
    }
};
